import script from "./Modelling.vue?vue&type=script&setup=true&lang=ts"
export * from "./Modelling.vue?vue&type=script&setup=true&lang=ts"

import "./Modelling.vue?vue&type=style&index=0&id=712a4300&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-712a4300"]])

export default __exports__